<h2 mat-dialog-title>Are you sure?</h2>
<mat-dialog-content>
  <p>This will delete the <b>whole creche</b> structure with <b>photos</b>, <b>users</b> and <b>accounts</b>!</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button [mat-dialog-close]="true" color="warn" mat-button>Delete</button>
</mat-dialog-actions>